import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Factuur } from '../dto/factuur';
import { CrudService, Filter, FilterOperator } from '@mango/core';
import { map } from 'rxjs/operators';
import { DocumentDownloadResponse } from './projectregel.service';
import { exportExact } from '../dto/exportExact';

@Injectable({ providedIn: 'root' })
export class FactuurService extends CrudService<Factuur> {

    constructor(injector: Injector) { super(Factuur, injector); }

    FactuurGenereren(factuur: Factuur) {
        let query: string = `api/dto/factuur/FactuurGenereren?factuurId=${factuur.id}`;

        return this.http.post(query, null).pipe(map(x => x as FactuurResponse));

    }
    
    FactuurGoedkeuren(factuur: Factuur) {
        let query: string = `api/dto/factuur/FactuurGoedkeuren?factuurId=${factuur.id}`;

        return this.http.post(query, null).pipe(map(x => x as FactuurResponse));

    }

    FactuurGoedkeuringTerugdraaien(factuur: Factuur) {
        let query: string = `api/dto/factuur/FactuurGoedkeurenTerugdraaien?factuurId=${factuur.id}`;

        return this.http.post(query, null).pipe(map(x => x as FactuurResponse));

    }

    ExporterenExactTerugdraaien(factuur: Factuur) {
        let query: string = `api/dto/factuur/ExporterenExactTerugdraaien?factuurId=${factuur.id}`;

        return this.http.post(query, null).pipe(map(x => x as FactuurResponse));

    }

    DownloadFactuur(id: number) {

        let query: string = `api/dto/projectregel/DownloadFactuur?factuurId=${id}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

    ExportFactuurExact(id: number) {

        let query: string = `api/dto/factuur/FactuurExportExact?factuurId=${id}`;

        return this.http.post(query, null).pipe(map(x => x as FactuurResponse));
    }

    CopyFactuur(factuur: Factuur) {
        let query: string = `api/dto/factuur/FactuurKopieren?factuurId=${factuur.id}`;

        return this.http.post(query, null).pipe(map(x => x as FactuurResponse));

    }

    SetMailDatum(factuur: Factuur) {
        let query: string = `api/dto/factuur/SetMailDatum?Id=${factuur.id}`;

        return this.http.post(query, null).pipe(map(x => x as FactuurResponse));

    }

    exporteerFacturenExcel(filter: Filter<Factuur>) {
        
        let f = `filter=${encodeURIComponent(JSON.stringify(this.convertFilter(filter) ))}`;
        let query: string = `/api/dto/factuur/Exporteer?${f}`;
             
        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

    exporteerFacturen(facturen: Factuur[]) {
                    
            var eE = new exportExact();
            eE.facturen = facturen;
                    
            let query: string = `api/dto/factuur/ExporteerFacturen`;

            return this.http.post(query, eE).pipe(map(x => x as FactuurResponse));
        }
        
    private convertFilter (f: Filter<Factuur>, arr: any[] = [] ) {
        for(let fp of f.getProperties()) {
            arr.push(fp);
        };

        let isEmpty = (str)=>typeof(str)=='string' && str.trim() == "";

        Object.keys(f).forEach(x => {
            if(Object.keys(new Filter<Factuur>()).indexOf(x) === -1 && f[x] != null && !isEmpty(f[x])) {
                let customProperty = {};
                customProperty[x] = f[x];
                arr.push(customProperty);
            }
        });

        f.filters.forEach(subF => {
            let andOrItem = {};
            let subArr = [];
            this.convertFilter(subF, subArr);
            andOrItem[subF.filterOperator == FilterOperator.And ? "and" : "or"] = subArr;
            arr.push(andOrItem);
        });

        return arr;
    }

    ConvertResponseToBlob(response: DocumentDownloadResponse, sliceSize = 512) {
        const byteCharacters = atob(response.file);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: response.fileMimeType });
        return blob;
    }
    
}

export class FactuurResponse {
    successful: boolean;
    message: string;
    factuurId: number;
}